import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// date-fns format string, day-month-year, e.g. "24 September 2026"
export const DISPLAY_DATE_FORMAT = "d MMMM yyyy"
